import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import UiInputsPage from './ui-inputs'

const uiRoutes: Route[] = [
  {
    path: Paths.UI_INPUTS_PAGE,
    element: <UiInputsPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default uiRoutes
